import { z } from 'zod';

export const imageFormatSchema = z.object({
  name: z.string(),
  generator: z.string(),
  extension: z.string(),
});
